module.exports = __webpack_public_path__ + "static/media/er.bdfbf04c.svg";